// Local lesson matching: powers the library search box and is the offline fallback for the concierge.
import { CEFR, lessons, type CatalogLesson as Lesson } from "../../shared/catalog";

const SKILL_WORDS: Record<string, string[]> = {
  A: ["grammar", "tense", "tenses", "verb", "verbs", "structure"],
  B: ["vocabulary", "vocab", "words", "idioms", "collocations"],
  C: ["reading", "read", "texts", "comprehension", "article"],
  D: ["writing", "write", "essay", "essays", "paragraph"],
  E: ["listening", "speaking", "speak", "talk", "pronunciation", "oral", "fluency"],
  F: ["assessment", "review", "revision", "exam", "test", "tests", "rubric"],
};
const STOP = new Set("a an the and or for of to in on with my our is are they them their i we class students lesson lessons need want".split(" "));

export function tokens(q: string) {
  return q.toLowerCase().normalize("NFKD").replace(/[^a-z0-9\s-]/g, " ").split(/\s+/).filter((t) => t.length > 1 && !STOP.has(t));
}

function haystack(l: Lesson) {
  return `${l.id} ${l.topic} ${l.activity} ${l.objective} ${l.skill} ${l.tags.join(" ")}`.toLowerCase();
}
const HAY = new Map(lessons.map((l) => [l.id, haystack(l)]));

export function levelIn(l: Lesson, level: string) {
  const i = CEFR.indexOf(level as (typeof CEFR)[number]);
  return l.mixedLevel || (i >= l.levelIndex[0] && i <= l.levelIndex[1]);
}

export function scoreLessons(query: string): { lesson: Lesson; score: number }[] {
  const q = query.toLowerCase();
  const toks = tokens(query);
  const level = /\b(pre-?a1|a1|a2|b1|b2|c1)\b/i.exec(q)?.[1]?.toUpperCase().replace("PREA1", "Pre-A1").replace("PRE-A1", "Pre-A1");
  const negWriting = /(hate|don't like|dislike|avoid|no)\s+writ/.test(q);
  return lessons
    .map((lesson) => {
      const hay = HAY.get(lesson.id)!;
      let score = 0;
      if (q.trim().toUpperCase() === lesson.id) score += 100;
      for (const t of toks) {
        if (hay.includes(t)) score += t.length > 4 ? 3 : 2;
        if (SKILL_WORDS[lesson.section].includes(t)) score += 4;
      }
      if (level && levelIn(lesson, level)) score += 3;
      if (negWriting && lesson.tags.includes("writing-output")) score -= 4;
      if (/(energy|fun|game|bored|lively)/.test(q) && lesson.tags.includes("competitive")) score += 3;
      if (/(big|large|forty|40|fifty|50)/.test(q) && lesson.tags.includes("movement")) score += 1;
      return { lesson, score };
    })
    .filter((x) => x.score > 0)
    .sort((a, b) => b.score - a.score);
}
